import * as actionTypes from '../actions/Actions';

export const initialState = {
  data: {
    isOpen: false,
    title: '',
    message: '',
    feature: '',
    record: null,
    status: 0,
    notify: '',
    style: ''
  },
};

// ==============================|| Otp REDUCER ||============================== //

const confirmPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_CONFIRM_PASSWORD_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          title: action.title,
          message: action.message,
          feature: action.feature,
          notify: ''
        }
      };
    case actionTypes.SHOW_MERCHANT_CONFIRM_PASSWORD_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          title: action.title,
          message: action.message,
          record: action.record,
          feature: action.feature,
          notify: ''
        }
      }
    case actionTypes.MERCHANT_STATUS_CHANGE:
      return {
        ...state,
        data: {
          ...state.data,
          status: action.status,
        }
      }
    case actionTypes.GET_MESSAGE:
      return {
        ...state,
        data: {
          ...state.data,
          notify: action.notify,
          style: action.style
        }
      }
    case actionTypes.CLEAR_MESSAGE:
      return {
        ...state,
        data: {
          ...state.data,
          notify: '',
          style: '',
          // status: 0
        }
      }

    case actionTypes.CLOSE_CONFIRM_PASSWORD_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: false,
          title: '',
          message: '',
          feature: '',
          // record: null
        }
      };

    default:
      return state;
  }
};

export default confirmPasswordReducer;
